'use strict';

export default class LoginController {
  /*@ngInject*/
  constructor($auth, $scope, $mdToast) {
    this.loginInfo = {
      email: '',
      password: ''
    };
    //this.submitLogin = $auth.submitLogin();
    this.$auth = $auth;
    this.buttonDisabled = false;
    this.$mdToast = $mdToast;

    $scope.$on('auth:login-error', (ev, reason) => {
      this.buttonDisabled = false;

      if(reason.errors[0].indexOf('A confirmation email was sent') !== -1) {
        this.showToast('パスワードが未設定です。パスワード設定用メールが送られていないか確認してください。');
      } else {
        this.showToast('ログインIDまたはパスワードが違います');
      }
    });
  }

  submitLogin() {
    this.$auth.submitLogin(this.loginInfo);
  }

  disableButton() {
    this.buttonDisabled = true;
  }

  showToast(message) {
    this.$mdToast.show(
        this.$mdToast.simple()
            .content(message)
            .position('top left right')
            .hideDelay(3000)
    );
  }
}



// WEBPACK FOOTER //
// ./public/dev/app/account/login/login.controller.js